var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 14,
    viewBox: "0 0 160 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.79503 12.9533L11.7755 0.775879H10.01L5.82867 11.2919L1.6473 0.775879H-0.118164L4.88089 12.9533H6.79503Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9356 12.9533V11.6023H21.3569V7.40318H27.8055V6.05216H21.3569V2.1269H27.9356V0.775879H19.8145V12.9533H27.9356Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.354 12.9533V3.24058L45.5831 12.9533H47.0698V0.775879H45.5273V10.2878L38.3911 0.775879H36.8115V12.9533H38.354Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4464 13.1724C64.8101 13.1724 66.5198 11.2372 66.5198 8.20649V0.775879H64.9588V8.18823C64.9588 10.4156 63.7322 11.8214 61.4464 11.8214C59.1606 11.8214 57.9526 10.4156 57.9526 8.18823V0.775879H56.3916V8.22475C56.3916 11.2189 58.1013 13.1724 61.4464 13.1724Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M83.9629 12.9533V11.6023H77.3843V7.40318H83.8328V6.05216H77.3843V2.1269H83.9629V0.775879H75.8418V12.9533H83.9629Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M96.1465 12.9533V6.78244L100.718 12.9533H104.323V0.775879H100.569V6.5451L96.258 0.775879H92.3926V12.9533H96.1465Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M122.156 12.9533V9.74008H116.507V8.40732H122.026V5.19408H116.507V3.98912H122.156V0.775879H112.753V12.9533H122.156Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M133.336 12.9533L135.603 9.22888L137.87 12.9533H142.293L138.149 6.69116L142.015 0.775879H137.573L135.603 4.24471L133.596 0.775879H129.192L133.057 6.70941L128.913 12.9533H133.336Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M155.796 12.9533V3.98912H159.104V0.775879H148.716V3.98912H152.042V12.9533H155.796Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLogo);
export default __webpack_public_path__ + "static/media/IconLogo.eb21f79dba903f256e27a090048197b8.svg";
export { ForwardRef as ReactComponent };